"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Tooltip } from "@xefi/x-react/tooltip";
type Props = {
  title: string;
  children: ReactNode;
};
export const CustomTooltip = t0 => {
  const $ = _c(3);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== title) {
    t1 = <Tooltip trigger={children} content={title} placement="top" delay={150} className="text-xs" />;
    $[0] = children;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};